export enum MaterialType {
  POST = 1,
  DELIVERY = 2,
  STORE = 3,
  MANUAL = 4
}
